export default __webpack_public_path__ + "static/revolving_door_w.5d586b75c73792effe5afed4368f3f08.svg";